var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Box, Grid, CircularProgress, Dialog, DialogContent, IconButton, Divider, Typography, Tooltip, } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { QRCodeCanvas } from "qrcode.react";
import { getPaymentMaymentMethodIcon } from "./radom-payment-configs";
var RadomPaymentDialog = function (_a) {
    var opened = _a.opened, loading = _a.loading, asset = _a.asset, paymentData = _a.paymentData, onExpired = _a.onExpired, onClose = _a.onClose;
    var _b = useState(0), timeLeft = _b[0], setTimeLeft = _b[1];
    useEffect(function () {
        if (paymentData) {
            var expiry = new Date(paymentData.expiresAt).getTime();
            var now = Date.now();
            var diffInSeconds = Math.max(Math.floor((expiry - now) / 1000), 0);
            setTimeLeft(diffInSeconds);
            var interval_1 = setInterval(function () {
                setTimeLeft(function (prev) {
                    if (prev <= 1) {
                        clearInterval(interval_1);
                        onExpired();
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return function () { return clearInterval(interval_1); };
        }
    }, [paymentData]);
    var formatTime = function (seconds) {
        var m = Math.floor(seconds / 60)
            .toString()
            .padStart(2, "0");
        var s = (seconds % 60).toString().padStart(2, "0");
        return "".concat(m, ":").concat(s);
    };
    var handleCopy = function (text) {
        navigator.clipboard.writeText(text);
    };
    var handleClose = function (event, reason) {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };
    return (_jsx(Dialog, __assign({ open: opened, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", fullWidth: true }, { children: _jsx(DialogContent, { children: loading || !paymentData ? (_jsx(Box, __assign({ sx: {
                    width: "100%",
                    height: 200,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                } }, { children: _jsx(CircularProgress, { color: "inherit", size: 60 }) }))) : (_jsxs(Box, __assign({ p: 2, display: "flex", flexDirection: "column", alignItems: "center" }, { children: [_jsx(QRCodeCanvas, { value: "".concat(asset, ":").concat(paymentData.paymentAddress, "?amount=").concat(paymentData.paymentTotal), size: 180, imageSettings: {
                            src: getPaymentMaymentMethodIcon(asset),
                            x: undefined,
                            y: undefined,
                            height: 32,
                            width: 32,
                            excavate: true,
                        } }), _jsxs(Box, __assign({ mt: 3, width: "100%" }, { children: [_jsxs(Typography, __assign({ variant: "caption", color: "textSecondary" }, { children: ["PAYMENT ADDRESS", _jsx(Tooltip, __assign({ title: "Copy" }, { children: _jsx(IconButton, __assign({ size: "small", onClick: function () { return handleCopy(paymentData.paymentAddress); } }, { children: _jsx(ContentCopyIcon, { fontSize: "inherit" }) })) }))] })), _jsx(Typography, __assign({ variant: "body2", mb: 2 }, { children: paymentData.paymentAddress })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsxs(Grid, __assign({ item: true, xs: 6 }, { children: [_jsx(Typography, __assign({ variant: "caption", color: "textSecondary" }, { children: "NETWORK" })), _jsxs(Typography, __assign({ variant: "body2" }, { children: [_jsx("img", { src: getPaymentMaymentMethodIcon(paymentData.method.network), alt: "usdc", style: { width: 16, height: 16, verticalAlign: "middle", marginRight: 4 } }), paymentData.method.network] }))] })), _jsxs(Grid, __assign({ item: true, xs: 6 }, { children: [_jsxs(Typography, __assign({ variant: "caption", color: "textSecondary" }, { children: ["AMOUNT DUE", _jsx(Tooltip, __assign({ title: "Copy" }, { children: _jsx(IconButton, __assign({ size: "small", onClick: function () { return handleCopy(String(paymentData.paymentTotal)); } }, { children: _jsx(ContentCopyIcon, { fontSize: "inherit" }) })) }))] })), _jsxs(Typography, __assign({ variant: "body2" }, { children: [_jsx("img", { src: getPaymentMaymentMethodIcon(asset), alt: "usdc", style: { width: 16, height: 16, verticalAlign: "middle", marginRight: 4 } }), paymentData.paymentTotal, " ", asset] }))] }))] })), _jsxs(Box, __assign({ mt: 2 }, { children: [_jsx(Typography, __assign({ variant: "caption", color: "textSecondary" }, { children: "TIME REMAINING" })), _jsx(Typography, __assign({ variant: "body2" }, { children: formatTime(timeLeft) }))] })), _jsx(Divider, { sx: { my: 3 } }), _jsx(Typography, __assign({ variant: "body2", color: "textSecondary", textAlign: "center", width: "100%" }, { children: "Please contact support if there are any problems" }))] }))] }))) }) })));
};
export default RadomPaymentDialog;
